import { env } from '@/env.mjs';

export const REGISTRATION = `${env.NEXT_PUBLIC_ORDER_API_URL}/v3/registrations`;
export const REGISTRATION_PASSWORD_RESET = `${env.NEXT_PUBLIC_ORDER_API_URL}/v3/registrations/reset-password`;
